export function heroSlideTitle(slide) {
	return (
		slide.webinar_title ||
		slide.workshop_title ||
		slide.video_clip_title ||
		slide.doctor_name ||
		""
	);
}

export function heroSlideCardProps(slide) {
	const href = slide.link_href || slide.url || "#";
	return {
		href,
		external: Boolean(slide.link_external),
		imageUrl: slide.image_url,
		title: heroSlideTitle(slide),
		showWebinarStatus:
			slide.target_type === "webinar" &&
			slide.show_webinar_countdown !== false,
		webinarStartDatetime: slide.webinar_start_datetime || null,
		showFreeBadge: false,
	};
}
